import { useTranslation } from "react-i18next"

import { AboutMeForm } from "./about-me-form"

export type AboutMePanelProps = {
  active: boolean
  onClose?: () => void
}

export function AboutMePanel({ active, onClose }: AboutMePanelProps) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-4">
      <div>
        <h3 className="text-base font-semibold">{t("personalization.aboutMe.title")}</h3>
        <p className="text-muted-foreground text-sm">{t("personalization.aboutMe.description")}</p>
      </div>

      <AboutMeForm active={active} onSaved={onClose} />
    </div>
  )
}
